var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteBin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.361 4.534h-.139c.077 0 .14-.06.14-.134zh5.277V4.4c0 .073.062.133.139.133h-.14v1.2h1.25V4.4c0-.588-.497-1.067-1.11-1.067H7.222c-.613 0-1.11.479-1.11 1.067v1.334h1.25zm8.75 1.2H3.89a.544.544 0 0 0-.556.533V6.8c0 .074.063.134.14.134H4.52l.429 8.716c.027.568.517 1.017 1.11 1.017h7.881c.594 0 1.082-.447 1.11-1.017l.428-8.716h1.049c.076 0 .139-.06.139-.134v-.533a.544.544 0 0 0-.556-.534m-2.304 9.733H6.193l-.42-8.533h8.455z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteBin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-bin.40e233d7.svg";